export const ITEM_LIST_TITLE = `יתרונות "הכל מראש" של WeCheck`